import store from '@/store'
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home/index.vue'

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			menus: [
				// { name: 'Blog', to: 'blog' },
				{
					name: 'Channel',
					icon: 'icon-youtube',
					href: store.state.App.youtube.channel,
				},
			],
		},
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/'
	}
	// {
	// 	path: '/blog',
	// 	component: () =>
	// 		import(/* webpackChunkName: "blog" */ '../views/Blog/index.vue'),
	// 	children: [
	// 		{
	// 			path: '',
	// 			name: 'Articles',
	// 			component: () =>
	// 				import(
	// 					/* webpackChunkName: "blog" */ '../views/Blog/Articles/List.vue'
	// 				),
	// 		},
	// 		{
	// 			path: '/blog/:article',
	// 			name: 'Article',
	// 			component: () =>
	// 				import(
	// 					/* webpackChunkName: "blog" */ '../views/Blog/Articles/Details.vue'
	// 				),
	// 		},
	// 	],
	// },
	// {
	// 	path: '/blog/:article/:chapter',
	// 	name: 'Chapter',
	// 	component: () =>
	// 		import(
	// 			/* webpackChunkName: "blog" */ '../views/Blog/Chapters/index.vue'
	// 		),
	// },
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
})

router.afterEach(() => {
	window.scrollTo({ top: 0, behavior: 'smooth' })
})

export default router
